<template>
    <div class="page">
        <header-component @openMenu="openMenu" :menuOpen="menu"/>
        <main class="main">
            <sidebar-component :menu="menu"/>
            <div class="content">
                <router-view></router-view>
            </div>
        </main>
    </div>
</template>

<script setup lang="ts">
    import sidebarComponent from "../components/sidebarComponent.vue"
    import headerComponent from "../components/headerComponent.vue";
    import { ref } from "vue";
    import { RouterView } from "vue-router";

    let menu = ref(false)
    const openMenu = () => menu.value = !menu.value
</script>